import React from 'react';
import HeaderButton from './HeaderButton';
import iconPrint from '../public/images/print.svg';

const PrintButton: React.FC = () => {
  return (
    <HeaderButton
      icon={iconPrint}
      alt="print"
      label="Print"
      onClick={() => document.execCommand('print')}
      tooltip="Print"
    />
  );
};

export default PrintButton;
